/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Member Campsite Schema
 * @export
 * @interface MemberCampsite
 */
export interface MemberCampsite {
    /**
     * Member ID
     * @type {string}
     * @memberof MemberCampsite
     */
    memberId: string;
    /**
     * Campsite ID
     * @type {string}
     * @memberof MemberCampsite
     */
    campsiteId: string;
    /**
     * Created Date
     * @type {Date}
     * @memberof MemberCampsite
     */
    createdDate: Date;
    /**
     * Updated Date
     * @type {Date}
     * @memberof MemberCampsite
     */
    updatedDate: Date;
    /**
     * Deleted Date
     * @type {Date}
     * @memberof MemberCampsite
     */
    deletedDate: Date;
}

/**
 * Check if a given object implements the MemberCampsite interface.
 */
export function instanceOfMemberCampsite(value: object): value is MemberCampsite {
    if (!('memberId' in value) || value['memberId'] === undefined) return false;
    if (!('campsiteId' in value) || value['campsiteId'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined) return false;
    if (!('deletedDate' in value) || value['deletedDate'] === undefined) return false;
    return true;
}

export function MemberCampsiteFromJSON(json: any): MemberCampsite {
    return MemberCampsiteFromJSONTyped(json, false);
}

export function MemberCampsiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberCampsite {
    if (json == null) {
        return json;
    }
    return {
        
        'memberId': json['member_id'],
        'campsiteId': json['campsite_id'],
        'createdDate': (new Date(json['created_date'])),
        'updatedDate': (new Date(json['updated_date'])),
        'deletedDate': (new Date(json['deleted_date'])),
    };
}

export function MemberCampsiteToJSON(value?: MemberCampsite | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'member_id': value['memberId'],
        'campsite_id': value['campsiteId'],
        'created_date': ((value['createdDate']).toISOString()),
        'updated_date': ((value['updatedDate']).toISOString()),
        'deleted_date': ((value['deletedDate']).toISOString()),
    };
}

